module.exports = __webpack_public_path__ + "static/media/素沙茶蒟蒻.3fe98384.jpg";